<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <size-information-parameter-create-or-update v-model="parameter" :errors="errors"></size-information-parameter-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :buttons="buttons"
                    :fields="fields"
                    name="size-information-parameter"
                    pagination="server"
                    search
                    :items-provider="provider"
                    :add-callback="createNew"></v-table>

    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SizeInformationParameterCreateOrUpdate from './components/SizeInformationParameterCreateOrUpdate.vue';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
export default {
    components:{
        BCard,
        SizeInformationParameterCreateOrUpdate
    },
    data () {
        return {
            fields:[
                {name:"Beden",key:"SizeInformationName", thClass:"w-50",sortable:true},   
                {name:"Değer",key:"Value", thClass:"w-50",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            loading:false,
            errors:{},
            parameter:{
                Id:null,
                SizeInformationId:null,
                Value:null,
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.parameter.Id = null
            this.parameter.SizeInformationId = null
            this.parameter.Value = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HumanResourcesParameterApi.SizeInformationParameter.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.parameter.Id = item.Id
            this.parameter.SizeInformationId = item.SizeInformationId
            this.parameter.Value = item.Value
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.SizeInformationParameter.CreateOrUpdate(this.editing,this.parameter).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.SizeInformationName} beden bilgisine ait ${item.Value} değerini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.SizeInformationParameter.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        
    }

}
</script>

<style>

</style>